// ✅ BetAmountPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar2 from "../components/navbar/Navbar2";
import AOS from "aos";
import "aos/dist/aos.css";
import { socket } from "../api";
import LoadingPage from "./LoadingPage";
import DigitalTimer from "./DigitalTimer";
import { useTranslation } from "react-i18next";
import Footer from "../components/navbar/Footer";

const BetAmountPage = () => {
  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t: translate } = useTranslation(["BetAmountPage"]);

  useEffect(() => {
    AOS.init({ duration: 500, easing: "ease-in-sine" });

    // 🔁 Always request full room list on mount
    socket.emit("get-rooms");

    // ✅ FULL SNAPSHOT (authoritative)
    socket.on("room-list", (list) => {
      setRooms((prev) => {
        // First load → sort and set
        if (prev.length === 0) {
          return [...list].sort((a, b) => Number(a.id) - Number(b.id));
        }

        // After first load → MERGE only (no replace, no sort)
        return prev.map((room) => {
          const fresh = list.find((r) => r.roomId === room.roomId);
          return fresh ? { ...room, ...fresh } : room;
        });
      });

      setLoading(false);
    });

    // ✅ SINGLE ROOM UPDATE (authoritative)
    socket.on("room-update", (updatedRoom) => {
      setRooms((prev) =>
        prev.map((room) =>
          room.roomId === updatedRoom.roomId
            ? { ...room, ...updatedRoom }
            : room,
        ),
      );
    });

    // 🔄 Safety sync every second (prevents stale UI)
    const syncInterval = setInterval(() => {
      socket.emit("get-rooms");
    }, 1000);

    return () => {
      socket.off("room-list");
      socket.off("room-update");
      clearInterval(syncInterval);
    };
  }, []);

  const handleJoinClick = (room) => {
    if (room.status === "playing") {
      navigate("/play", {
        state: {
          roomInfo: room,
        },
      });
    } else {
      navigate(
        `/select-cards?room=${room.roomId}&stake=${room.amount}&win=${room.winAmount}`,
      );
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="min-h-screen bg-primary text-white">
      <div className="fixed left-0 right-0 top-0 z-50 bg-gradient-to-l from-cyan-900 via-cyan-800 to-cyan-900">
        <Navbar2 />
      </div>

      <div className="text-center pt-36 md:pt-20">
        <h1 className="text-2xl font-semibold font-serif">
          {translate("Select_Stack")}
        </h1>
      </div>

      <div className="mt-10 flex justify-center">
        <div className="w-full max-w-4xl bg-[#134454] rounded-lg overflow-hidden shadow-xl">
          <div className="grid grid-cols-4 bg-[#185163] text-center font-semibold py-3 font-serif">
            <div>{translate("Stake")}</div>
            <div>{translate("Status")}</div>
            <div>{translate("Possible_Win")}</div>
            <div>{translate("Join")}</div>
          </div>

          {rooms.map((room) => {
            let displayStatus = "Waiting";

            if (room.status === "counting") {
              displayStatus = `${room.countdown}s`;
            }

            if (room.status === "playing") {
              displayStatus = "Playing";
            }

            return (
              <div
                key={room.roomId}
                className="grid grid-cols-4 text-center items-center py-3 border-b border-[#185163] hover:bg-[#185163] font-serif"
              >
                <div>
                  {room.amount} {translate("ETB")}
                </div>

                <div className="text-sm">
                  {room.status === "counting" ? (
                    <DigitalTimer seconds={room.countdown} />
                  ) : room.status === "playing" ? (
                    <span className="text-green-400">Playing</span>
                  ) : (
                    <span className="text-gray-300">Waiting</span>
                  )}
                </div>

                <div>{room.winAmount ? `${room.winAmount} Birr` : "—"}</div>

                <div>
                  <button
                    onClick={() => handleJoinClick(room)}
                    //  disabled={room.status === "playing"}
                    className={`px-4 py-1 rounded-lg ${
                      room.status === "playing"
                        ? "bg-gray-600"
                        : "bg-gradient-to-r from-primary to-[#6784a4] hover:opacity-90"
                    }`}
                  >
                    {room.status === "playing"
                      ? translate("Open")
                      : translate("Start")}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BetAmountPage;
